export const hour = 1000 * 60 * 60

export const day = hour * 24

export const week = day * 7

export const month = day * 30
